import React from 'react'
import { useTranslation } from 'react-i18next'

import { useSaveSegments } from './_requests/saveSegments'
import BulkForm from '../../../packages/kiti/components/form/form/BulkForm'
import Form from '../../../packages/kiti/components/form/form/Form'
import Line from '../../../packages/kiti/components/helpers/Line'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import GroupSelect from '../../../containers/groups/select/GroupSelect'
import ChecklistTypesSelectV2 from '../../../containers/checklistTypes/select/ChecklistTypesSelectV2'
import PlaceLevelsSelectV2 from '../../../containers/places/placeLevelsSelect/PlaceLevelsSelectV2'
import AssetSelect from '../../../containers/assets/select/AssetSelect'

const initialItemValue = {
  name: '',
  userGroups: [],
  checklistTypes: [],
  placeLevels: []
}

const EditSegmentsForm = () => {
  const { t } = useTranslation('editSegmentation')
  const [onSubmit, { loading, error }] = useSaveSegments(true)

  const initialState = [initialItemValue]

  return (
    <Form onSubmit={!loading ? onSubmit : undefined} initialState={initialState}>
      <Scroll height="69vh" scroll scrollX direction="column">
        <Separator weight={8} flex={1}>
          <BulkForm
            disableMultiEdit={true}
            isEditing={false}
            initialItemState={initialItemValue}
            fields={[
              { label: t('generalStep.name'), name: 'name', width: 20 },
              {
                label: t('bulkEdit.fields.checklistTypes'),
                name: 'checklistTypes',
                Input: ChecklistTypesSelectV2,
                width: 20,
                dynamicProps: () => ({ idField: 'id', multiple: true, canCreate: false })
              },
              {
                label: t('bulkEdit.fields.userGroups'),
                name: 'userGroups',
                Input: GroupSelect,
                width: 20,
                dynamicProps: () => ({ idField: 'id', multiple: true, canCreate: false })
              },
              {
                label: t('bulkEdit.fields.placeLevels'),
                name: 'placeLevels',
                Input: PlaceLevelsSelectV2,
                width: 20,
                dynamicProps: () => ({ idField: 'id', multiple: true, canCreate: false })
              },
              {
                label: t('bulkEdit.fields.assets'),
                name: 'assets',
                Input: AssetSelect,
                width: 20,
                dynamicProps: () => ({ idField: 'id', multiple: true, canCreate: false })
              }
            ]}
          />
        </Separator>
      </Scroll>
      <Line />
      <Separator paddingH={2}>
        <SubmitBar loading={loading} error={error} />
      </Separator>
    </Form>
  )
}

export default EditSegmentsForm
